import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import { useField } from 'formik';
import InputWrapper from '../InputWrapper';

interface RadioSelectProps {
  name: string;
  label: string;
  isLabelMultiline?: boolean;
  disabled?: boolean;
  options: {
    value: string | boolean | number;
    label: string;
    category?: string;
  }[];
  tooltip?: string;
  required?: boolean;
}

function RadioSelect({
  name,
  label,
  isLabelMultiline,
  disabled,
  options,
  tooltip,
  required,
}: RadioSelectProps) {
  const [{ value }, , { setValue, setTouched }] = useField<
    string | boolean | number
  >(name.toString());

  return (
    <InputWrapper
      label={label}
      isLabelMultiline={isLabelMultiline}
      name={name}
      tooltip={tooltip}
      required={required}>
      <Stack width="100%" alignItems="start" gap={1.5}>
        <Stack width="100%" gap={0.5}>
          <RadioGroup
            sx={{
              gap: 1,
            }}
            aria-labelledby={`radio-${name}`}
            name={name}
            value={value}
            onChange={e => {
              setValue(e.target.value);
              setTimeout(() => setTouched(true), 0);
            }}>
            {options.map(option => (
              <FormControlLabel
                key={String(option.value)}
                disabled={disabled}
                sx={{
                  bgcolor: '#ffffff',
                  borderRadius: '10px',
                  border: theme => `1px solid ${theme.palette.lightGrey.main}`,
                  py: 1.5,
                  px: 1,
                  m: 0,
                  '&:hover': {
                    bgcolor: disabled
                      ? undefined
                      : theme => theme.palette.lightGrey.main,
                  },
                }}
                value={option.value}
                label={
                  <Typography variant="body2" component="p" ml={1}>
                    {option.label}
                  </Typography>
                }
                control={<Radio sx={{ p: 0 }} />}
              />
            ))}
          </RadioGroup>
        </Stack>
      </Stack>
    </InputWrapper>
  );
}

export default RadioSelect;
